import React from 'react';
import { motion } from 'motion/react';
import { SparklesIcon, MoodboardIcon, UsersIcon, BatchIcon } from '../icons/Icons';

const steps = [
  {
    id: 'idealize',
    title: 'Idealize',
    description: 'Descubra tendências e crie produtos inspiradores para suas próximas coleções.',
    icon: <SparklesIcon className="w-8 h-8" />,
    color: 'from-pink-500 to-rose-500',
  },
  {
    id: 'planeje',
    title: 'Planeje',
    description: 'Estruture seus projetos, defina estilos e prepare os assets necessários.',
    icon: <MoodboardIcon className="w-8 h-8" />,
    color: 'from-snapfy-primary to-snapfy-accent-soft',
  },
  {
    id: 'organize',
    title: 'Organize',
    description: 'Gerencie seus modelos virtuais, paletas de cores e referências visuais em um só lugar.',
    icon: <UsersIcon className="w-8 h-8" />,
    color: 'from-blue-500 to-cyan-500',
  },
  {
    id: 'realidade',
    title: 'Torne Realidade',
    description: 'Gere fotos e vídeos de alta qualidade com modelos virtuais em segundos.',
    icon: <BatchIcon className="w-8 h-8" />,
    color: 'from-emerald-500 to-teal-500',
  },
];

const BusinessIntelligence: React.FC = () => {
  return (
    <div className="my-24 relative">
      <div className="absolute inset-0 bg-gradient-to-r from-snapfy-primary/5 via-transparent to-snapfy-primary/5 rounded-3xl -z-10 blur-3xl" />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6 }}
        className="text-center mb-16"
      >
        <h2 className="text-3xl md:text-4xl font-black tracking-tight text-snapfy-text-primary mb-4">
          A inteligência da Snapfy.ai em seu negócio de{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-snapfy-primary to-snapfy-accent-soft">
            ponta à ponta:
          </span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative">
        <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-snapfy-border to-transparent -translate-y-1/2 z-0" />

        {steps.map((step, index) => (
          <motion.div
            key={step.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5, delay: index * 0.15 }}
            className="relative z-10"
          >
            <div className="bg-snapfy-surface/60 backdrop-blur-xl border border-snapfy-border rounded-3xl p-8 h-full flex flex-col items-center text-center transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:shadow-snapfy-primary/10 hover:border-snapfy-primary/30 group">
              <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${step.color} p-0.5 mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                <div className="w-full h-full bg-snapfy-surface rounded-[14px] flex items-center justify-center text-snapfy-text-primary group-hover:bg-transparent group-hover:text-white transition-colors duration-300">
                  {step.icon}
                </div>
              </div>

              <h3 className="text-xl font-bold text-snapfy-text-primary mb-3">
                {step.title}
              </h3>

              <p className="text-snapfy-text-secondary text-sm leading-relaxed">
                {step.description}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default BusinessIntelligence;
